import React, { useState } from "react";
import styled from "styled-components";

import { useContext } from "react";
import { OptionItem } from "src/types";
import { ModalContext } from "../../context";
import { theme } from "../../utils/theme";
import { AppText, FlexDiv } from "../UI";
import { PhoenixAppButton, PhoenixMultiSelect } from "../UI/Phoenix";
import { Modal } from "./Modal";

export const SelectProductModal: React.FC = () => {
  const {
    showSelectProductModal,
    setShowSelectProductModal,
    selectedSale,
    setSelectedSale,
    setShowUpdateProductModal,
  } = useContext(ModalContext);

  const [selectedProduct, setSelectedProduct] = useState<OptionItem | undefined>(undefined);

  const handleCancel = () => setShowSelectProductModal(false);

  return (
    <Modal open={showSelectProductModal} onClose={() => setShowSelectProductModal(false)}>
      <EditCardDiv>
        <TitleDiv>
          <TitleText>Select a Product to Edit</TitleText>
        </TitleDiv>

        <FlexDiv direction="column" padding="0px 40px 72px 40px" gap={8}>
          <AppText fontSize={12} fontWeight={500} lineHeight={18}>
            Products Included in Sale
          </AppText>
          <PhoenixMultiSelect
            isMulti={false}
            name="product-list"
            options={
              selectedSale?.sale_item_list?.map((item: any) => ({
                label: item?.product?.product_title,
                value: item?.id,
              })) || []
            }
            placeholder="Select a Product"
            onChange={(e: any) => {
              setSelectedProduct(e);
            }}
            value={selectedProduct}
            isClearable={false}
            marginBottom={false}
            error={false}
            width={396}
            optionsContainerWidth={396}
            pointer
          />
        </FlexDiv>
        <SubmitDiv>
          <PhoenixAppButton variant="brand-outline" buttonType="secondary" onClick={handleCancel} uppercase>
            Cancel
          </PhoenixAppButton>
          <PhoenixAppButton
            variant="brand"
            buttonType="secondary"
            onClick={() => {
              setSelectedSale({
                ...selectedSale,
                sale_item_id: selectedProduct?.value as string,
              });
              handleCancel();
              setShowUpdateProductModal(true);
            }}
            uppercase
            disabled={!selectedProduct}
          >
            Continue
          </PhoenixAppButton>
        </SubmitDiv>
      </EditCardDiv>
    </Modal>
  );
};

const SubmitDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  border-top: 1px solid ${theme.border.neutral.secondary};
`;

const TitleText = styled(AppText)`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
`;

const TitleDiv = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 118px;
`;

const EditCardDiv = styled.div`
  z-index: 5;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 476px;
`;
